const doc = [({"installment":"Taksit ödemesi", "limited_subscription":"Sınırlı üyelik", "one_time":"Bir defalık", "subscription":"Üyelik"})];
module.exports = doc.length <= 1 ? doc[0] : doc;